import apiUrl from './../../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import utility from './../../../../utility/services/utility.service';
import Loader from './../../../../shared/components/loader'
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import {Validator} from 'vee-validate';
import ClientService from './../../../../clientmanagement/services/clientmanagement.service';
import Multiselect from 'vue-multiselect'
import iptracker from '../../../../../views/components/commonfunction/iptracker';

export default {
  name: 'changeclientname',
  components: {
    Treeselect,
    utility,
    ClientService,
    Multiselect,
    Loader,
    iptracker
  },
  data: function() {
    return {
      client: null,
      clientname:null,
      shipmentId: '',
      isLoading:false,
      showClientDetails:false,
      Clientlist:[],
      ActiveContract:"",
      businessaccountname:"",
      clientbusinessdetailid:"",
      clientbusinessaccountid:"",
      oldclientbusinessaccountid:"",
      DestinationPincode:"",
      OriginPincode:"",
      ParentAWB:"",
      RouteMode:"",
      TruckLoadType:"",
      BookingMode:"",
      ActiveContract:"",
      businessaccountname:"",
      clientbusinessdetailid:"",
      clientid:"",
      disablefields:true,
      disablefield:false,
      showclient:false,
      comments:'',
      shipmentStatus: "",
      approverName: "",
      userdetail:{}
    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userdetail = userdetail;
    this.userName = userdetail.email;
    this.getCompanyShortName();
  },
  methods: {
    async getCompanyShortName() {
        try {
          let InputPayload = {}
          var CompanyShortList = [];
          this.isLoading = true;
          let result = await ClientService.GetClientListByActiveContracts(InputPayload);
          CompanyShortList = result.data.data.rows;
          let tempArr = [];
          for (var i = 0; i < CompanyShortList.length; i++) {
            tempArr.push({
              'id': CompanyShortList[i].clientid,
              'label': CompanyShortList[i].clientcompanyname,
              'ContractId': CompanyShortList[i].id,
              'CompanyName': CompanyShortList[i].clientcompanyname,
              'ClientBusinessAccountId' : CompanyShortList[i].clientbusinessaccountid,
              'ClientBusinessDetailId' :  CompanyShortList[i].clientbusinessdetailid,
            });
          }
          this.isLoading = false;
         this.Clientlist = tempArr.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i);
        } catch (err) {
          console.log(err);
        }
      },
      selectClient(data){
        if(data){
          this.ActiveContract = data.ContractId;
          this.businessaccountname = data.CompanyName;
          this.clientbusinessdetailid = data.ClientBusinessDetailId;
          this.clientbusinessaccountid = data.ClientBusinessAccountId;
        }
    },
    reset() {
      this.shipmentId = '';
      this.client = null;
      this.clientname = null;
      this.showclient = false;
      this.$validator.reset();
      this.comments = '';
      this.disablefield = false;
    },
    async getclientDetails(){
      try{
        this.isLoading=true;
        let payload = {
          'awb': this.shipmentId
        }
        let result = await utility.getCargoClientDetails(payload);
        this.isLoading=false;
        if(result.data.code == 200){
          this.disablefield = true;
          let clientDetails = result.data.data.ResultData;
          if(clientDetails.status=="Invalid"){
            this.$alertify.error("Shipment status is Invalid. So you can not update client name.");
            return false;
          }else if(clientDetails.bookingstatus!="Complete"){
            this.$alertify.error("AWB booking status is Pending/Rapid. Please complete the booking process.");
            return false;
          }
          if (clientDetails.status == 'Delivered') {  // status is delivereed
            await this.chekApproval();
          } else {
            this.showclient = true;
          }
          this.shipmentStatus = clientDetails.status;
          if(this.Clientlist.length==0){
            this.getCompanyShortName();
          }
          this.Clientlist.map(el =>{
            if(el.id == clientDetails.ClientID)
            this.client = el.label;
          })
          this.client = {
            id: clientDetails.ClientID,
            label:clientDetails.BusinessAccountName,
            ContractId:clientDetails.ActiveContractID,
            CompanyName:clientDetails.BusinessAccountName,
            ClientBusinessAccountId:clientDetails.ClientBusinessAccountId,
            ClientBusinessDetailId:clientDetails.ClientBusinessDetailId
          }
          this.ActiveContract = clientDetails.ActiveContractID;
          this.businessaccountname =clientDetails.BusinessAccountName;
          this.clientbusinessdetailid = clientDetails.ClientBusinessDetailId;
          this.clientbusinessaccountid = clientDetails.ClientBusinessAccountId;
          this.oldclientbusinessaccountid = clientDetails.ClientBusinessAccountId;
          this.DestinationPincode = clientDetails.DestinationPincode;
          this.OriginPincode = clientDetails.OriginPincode;
          this.ParentAWB = clientDetails.ParentAWB;
          this.RouteMode = clientDetails.RouteMode;
          this.TruckLoadType = clientDetails.TruckLoadType;
          this.BookingMode = clientDetails.BookingMode;
          this.clientid = clientDetails.ClientID;
        }
        else{
          this.disablefield = false;
          this.$alertify.error(result.data.message);
        }
      }
      catch (err) {
        this.disablefield = false;
        console.log(err);
        this.isLoading = false;
      }
    },
    async chekApproval() {
      try {
        await this.$fire({
          text: "Shipment status is delivered. Do you have Finance Team approval?",
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
        }).then(async (result) => {
          if (result.value == true) {
            await this.$fire({
              title: 'Enter Approver Name',
              input: 'text',
              inputLabel: 'Approer Name',
              confirmButtonText: 'Submit',
              inputPlaceholder: 'Approver Name',
              inputAutoTrim: true,
              showCancelButton: true,
              inputValidator: (value) => {
                if (!value) {
                  return 'Approver Name is Required.'
                }
              }
            }).then(result => {
              if (result.value) {
                this.approverName = result.value;
                this.showclient = true;
              }
            })
          }
        }).catch((err) => {
          console.log(err)
        });
      } catch (error) {
        console.log(error);
      }
    },
    async updateclientDetails(){
      try{
         this.isLoading = true;
         let payload = {
          'awb':this.shipmentId,
	        'BusinessAccountName':this.businessaccountname,
	        'ClientBusinessAccountId':this.clientbusinessaccountid,
	        'ClientBusinessDetailId':this.clientbusinessdetailid.toString(),
	        'ClientID':this.clientid,
	        'ActiveContractID':this.ActiveContract,
	        'LastModifiedBy':this.userName,
          'TruckLoadType':this.TruckLoadType,
          'RouteMode': this.RouteMode,
          'BookingMode':this.BookingMode,
          'shipmentstatus' : this.shipmentStatus,
          'comments':this.comments
        }
        if (this.shipmentStatus == 'Delivered') {
          payload.approvername = this.approverName
        }
         let result = await utility.UpdateCargoClientDetails(payload);
         if(result.data.code == 200){
           this.oldclientbusinessaccountid = this.clientbusinessaccountid;
           this.comments = "";
           this.client = {
             id: this.clientid,
             label:this.businessaccountname,
             ContractId:this.ActiveContract,
             CompanyName:this.businessaccountname,
             ClientBusinessAccountId:this.clientbusinessaccountid,
             ClientBusinessDetailId:this.clientbusinessdetailid
           }
           this.$validator.reset();
           this.getTraceIP(payload);
           if(this.Clientlist.length==0){
             this.getCompanyShortName();
           }
           this.$alertify.success(result.data.data.ReturnMessage);
           this.isLoading=false;
         }
         else{
          this.$alertify.error(result.data.message)
         }
        this.isLoading=false;
       }
       catch (err) {
        console.log(err);
        this.isLoading = false;
      }
    },
    async onSubmit() {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.updateclientDetails();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    selectClient(data){
      if(data){
        this.ActiveContract = data.ContractId;
        this.businessaccountname = data.CompanyName;
        this.clientbusinessdetailid = data.ClientBusinessDetailId;
        this.clientbusinessaccountid = data.ClientBusinessAccountId;
        this.clientid = data.id
      }
    },
    async onSubmitSearch() {
        this.$validator.validateAll().then((result) => {
          if(result){
            this.getclientDetails(event);
          }
        }).catch(() => {
          console.log('errors exist', this.errors)
        });
      },
      getTraceIP(awbno) {
        let data =
          {
            "projectname": this.userdetail.project,
            "type": "web",
            "userid": this.userdetail.userid,
            "username": this.userdetail.username,
            "routeurl":'/changeclientname',
            "meta" : {
              "event" : `Change Client Name`,
              "data" : awbno
            }
        }
        let result = iptracker.getTraceIP(data);
      },
  }
}



// WEBPACK FOOTER //
// ./src/modules/utility/views/updateBookingDetails/changeclientname/changeclientname.component.js